import * as globals from '@wandb/weave/common/css/globals.styles';
import {Link} from '@wandb/weave/common/util/links';
import styled, {css} from 'styled-components';

export const ReportPageContainer = styled.div<{isViewMode?: boolean}>`
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  ${props => css`
    ${props.isViewMode && 'flex-direction: column;'}
  `}
`;

export const FCReportTags = styled.div`
  max-width: 788px;
  margin: 24px auto 0;
  padding: 0 36px;
  color: ${globals.THEME.textSecondary};
`;

export const FCReportTag = styled(Link)`
  &,
  &:hover {
    color: ${globals.THEME.textSecondary};
  }
`;

export const FCReportCTA = styled.div``;
